































import Vue from 'vue';

export interface ConfirmationPayload {
  maxWidth?: string;
  approveButtonClass?: string;
  approveButtonColor?: string;
  approveButtonOutlined?: string;
  approveButtonLoading?: boolean;
  approveName: string;
  cancelName: string;
  onConfirm: Function;
  onCancel: Function;
  onBeforeClose?: Function;
  header: string | Object;
  body: string | Object;
  askDontShowAgain?: boolean;
}

export default Vue.extend({
  name: 'ConfirmationDialog',

  data() {
    return {
      notificationShow: false,
      maxWidth: null as string | null,
      approveButtonClass: null as string | null,
      approveButtonOutlined: null as string | null,
      approveButtonColor: null as string | null,
      approveButtonLoading: false,
      approveName: null as string | null,
      cancelName: '',
      onConfirm: (() => null) as Function,
      onCancel: (() => null) as Function,
      onBeforeClose: (() => null) as Function,
      header: '' as string | Object,
      body: '' as string | Object,
      askDontShowAgain: false,
      form: { dontShowAgain: false }
    };
  },

  created() {
    this.$nuxt.$on('confirm', this.showDialog);
  },

  beforeDestroy() {
    this.$nuxt.$off('confirm', this.showDialog);
  },

  methods: {
    showDialog(payload: ConfirmationPayload) {
      this.resetState();
      this.maxWidth = payload.maxWidth || null;
      this.approveButtonClass = payload.approveButtonClass ?? null;
      this.approveButtonOutlined = payload.approveButtonOutlined ?? null;
      this.approveButtonColor = payload.approveButtonColor ?? null;
      this.approveName = payload.approveName;
      this.cancelName = payload.cancelName;
      this.onBeforeClose = payload.onBeforeClose;
      this.onConfirm = payload.onConfirm;
      this.onCancel = payload.onCancel;
      this.header = payload.header;
      this.body = payload.body;
      if (payload.askDontShowAgain)
        this.askDontShowAgain = !!payload.askDontShowAgain;
      this.notificationShow = true;
    },
    async onResult(result: boolean) {
      await this.onBeforeClose?.(result);
      this.notificationShow = false;
      if (result) {
        this.onConfirm?.({
          ...this.form
        });
      } else {
        this.onCancel?.(result);
      }
    },
    resetState() {
      this.notificationShow = false;
      this.maxWidth = null;
      this.approveButtonClass = null;
      this.approveButtonColor = null;
      this.approveButtonOutlined = null;
      this.approveName = null as string | null;
      this.cancelName = '';
      this.onConfirm = (() => null) as Function;
      this.onCancel = (() => null) as Function;
      this.header = '' as string | Object;
      this.body = '' as string | Object;
      this.askDontShowAgain = false as boolean;
      this.form = { dontShowAgain: false };
      this.approveButtonLoading = false;
    }
  }
});
